
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'

import PortalEasy from './close-easy-master.webp'
import PortalMedium from './close-medium-expert.webp'
import PortalHard from './close-hard.webp'

import PortalOpenWinEasy from './open-win-easy-master.webp'
import PortalOpenWinMedium from './open-win-medium-expert.webp'
import PortalOpenWinHard from './open-win-hard.webp'

import PortalOpenLoseEasy from './open-lose-easy-master.webp'
import PortalOpenLoseMedium from './open-lose-medium-expert.webp'
import PortalOpenLoseHard from './open-lose-hard.webp'

import { images, randomProperty } from './index.old' 
import { useAppDispatch, useAppSelector } from '../../store/hook' 
import { difficultyToAnime } from '.'

const defaultImageProps = {
    draggable: false,
    onContextMenu: (e: any) => e.preventDefault()
}

type ContentStateType = "hide" | "bomb" | "diamond" | "start";
export const Chest = ({ dataProps, idxChest, handleClick, selected, idxRow }: any) => {
    const dispatch = useAppDispatch();

    const [open, setOpen] = useState(false);
    const [contentState, setContentState] = useState<ContentStateType>("hide");
    const [shadowOpen, setShadowOpen] = useState(false);

    // const result = useAppSelector((state) => state.result);
    const playerbet = useAppSelector((state) => state.playerbet);
    const game = useAppSelector((state) => state.game);
    const history = useAppSelector((state) => state.history);

    // const [ isSelect, setIsSelect ] = useState(false);
    const sym = randomProperty(images);
    const ref: any = useRef(null);

    useEffect(() => {
        if (dataProps) {
            const result = dataProps;
            if (result.payload.zonk && result.payload.path && result.payload.path.includes(idxChest.toString()) && result.payload.zonk.includes(idxChest.toString())) {
                setShadowOpen(false);
                setContentState("bomb");

            }
            if (result.payload.path && result.payload.path.includes(idxChest.toString()) && (!result.payload.zonk || (result.payload.zonk && !result.payload.zonk.includes(idxChest.toString())))) {
                setShadowOpen(false);
                setContentState("diamond");
            }
            if (result.payload.zonk && result.payload.path && !result.payload.path.includes(idxChest.toString()) && result.payload.zonk.includes(idxChest.toString())) {
                setShadowOpen(true);
                setContentState("bomb");
            }
            if (result.payload.zonk && result.payload.path && !result.payload.path.includes(idxChest.toString()) && !result.payload.zonk.includes(idxChest.toString())) {
                setShadowOpen(true);
                setContentState("diamond");
            }
            setOpen(true);
        }
    }, []);

    const portalClose: any = {
       easy: PortalEasy,
       medium: PortalMedium,
       hard: PortalHard,
       expert: PortalMedium,
       master: PortalEasy,
    }

    const portalOpen: any = {
        easy: PortalOpenWinEasy,
        medium: PortalOpenWinMedium,
        hard: PortalOpenWinHard,
        expert: PortalOpenWinMedium,
        master: PortalOpenWinEasy,
     }

     const portalOpenLose: any = {
        easy: PortalOpenLoseEasy,
        medium: PortalOpenLoseMedium,
        hard: PortalOpenLoseHard,
        expert: PortalOpenLoseMedium,
        master: PortalOpenLoseEasy,
     }


    return <div key={`${dataProps ? "history" : "main"}-col-box-${idxChest}`} className="col">
        <div data-idxchest={idxChest} className={"chest chest-".concat(idxChest.toString()).concat(" ").concat(selected && !open ? " selected " : "").concat(!dataProps && selected && open && !shadowOpen ? " open " : "").concat(((!dataProps && !selected)||dataProps) && open && shadowOpen ? " shadowOpen " : "")} onClick={handleClick} >
            <img ref={ref} className="box" src={open && !["hide", "start"].includes(contentState) ? contentState == "bomb"?portalOpenLose[playerbet[playerbet.currMode].difficulty]:portalOpen[playerbet[playerbet.currMode].difficulty] : portalClose[playerbet[playerbet.currMode].difficulty]} alt="box"  {...{ ...defaultImageProps }} />
            {!["hide", "start"].includes(contentState) ? <Content {...{ contentState, sym, shadowOpen, difficulty: dataProps.data.detail_bet.difficulty }} /> : <></>}
        </div>
    </div>
}

interface ContentIProps {
    contentState: ContentStateType;
    sym: ReturnType<typeof randomProperty>;
    shadowOpen: boolean;
    difficulty: string;
}

const Content: React.FC<ContentIProps> = ({ contentState, sym, shadowOpen, difficulty }) => {

    const src = 'contentState == "bomb" ? Bomb : images[sym]';
    const ref: any = useRef(null);
    useLayoutEffect(() => {
        try {
            if (ref.current) {

                const obj = { curImg: 1 };
                // if (contentState == "bomb" && shadowOpen) {
                //     ref.current!.src = Bomb[0];

                // }

                // const tween = gsap.to(obj, 1,
                //     {
                //         curImg: src.length - 1,	// animate propery curImg to number of images
                //         roundProps: "curImg",				// only integers so it can be used as an array index
                //         repeat: contentState != "bomb" ? 0 : Infinity,
                //         immediateRender: true,			// load first image automatically
                //         ease: Linear.easeInOut,			// show every image the same ammount of time
                //         onStart: function () {
                //             if (ref.current) {

                //                 ref.current.previousSibling.style.position = "absolute";
                //             }
                //         },
                //         onUpdate: function () {
                //             if (ref.current) {
                //                 if (contentState == "bomb" && shadowOpen) {

                //                 } else {
                //                     if (shadowOpen) {

                //                         ref.current!.src = src[src.length - 1];
                //                     } else {

                //                         ref.current!.src = src[obj.curImg];
                //                     }

                //                 }
                //             }
                //         },
                //         onComplete: function () {

                //         }

                //     }
                // );
                // return () => {
                //     tween.kill()
                // }

            }
        } catch (error) {

        }
    }, []);

    return <>
        <img ref={ref} className="content" src={contentState=="bomb"?`/anim/spine/skeleton-assets/${difficultyToAnime[difficulty]}.png`:`/anim/spine/egg-anim real-assets/egg-${difficultyToAnime[difficulty]}.png`} alt="content"  {...{ ...defaultImageProps }} />
        {/* {contentState == "bomb" ? <img className="content bomb" src={Bomb[0]} alt="content"   {...{ ...defaultImageProps }} /> : <></>} */}
    </>
}